module.exports = __webpack_public_path__ + "static/media/6.1a876b8d.jpg";